import React from "react";
import { Check } from "lucide-react";

const amenities = [
  "Assistance with Activities of Daily Living",
  "Medication Management",
  "Nutritious Home-Style Meals",
  "Housekeeping & Laundry",
  "Social Activities & Events",
  "Family Engagement Opportunities",
  "Comfortable Private 1 BR / 1 BA Apartments",
  "Safe & Supportive Environment",
  "Medicaid / STAR+PLUS",
];

const AmenitiesSection = () => {
  return (
    <section id="amenities" className="purple-section" data-testid="amenities-section">
      <div className="container-hc py-20 md:py-28">
        <div className="text-xs font-bold tracking-[0.25em] text-[#a8c8e8]">
          OUR SERVICES
        </div>

        <h2 className="font-serif-display mt-5 text-4xl sm:text-5xl lg:text-6xl leading-[1.06] text-white max-w-4xl">
          Our services.
          <br />
          <span className="italic text-[#c4d8ec]">Everything home should be.</span>
        </h2>

        <p className="mt-7 max-w-2xl text-lg text-white/75 leading-relaxed">
          Personalized care, meaningful daily life, and the comfort of your own private
          apartment — all in one community.
        </p>

        <div className="mt-12 grid sm:grid-cols-2 lg:grid-cols-3 gap-3 max-w-5xl">
          {amenities.map((label) => (
            <div
              key={label}
              className="flex items-center gap-3 px-5 py-4 rounded-2xl bg-white/[0.06] border border-white/10 hover:bg-white/[0.1] transition-colors"
              data-testid={`amenity-${label.toLowerCase().replace(/[^a-z]+/g, "-")}`}
            >
              <span className="flex items-center justify-center w-7 h-7 rounded-full border-2 border-[#a8c8e8] flex-shrink-0">
                <Check size={14} className="text-[#a8c8e8]" strokeWidth={3} />
              </span>
              <span className="text-white text-[15px] font-medium">{label}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default AmenitiesSection;
